export default "__VITE_ASSET__DxIu0X0T__"